import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: `${import.meta.env.VITE_REACT_APP_BASE_URL}`,
});

let isAlertShown = false;

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (!token) {
      if (!isAlertShown) {
        isAlertShown = true;
        alert('Your session has expired. Please log in again.');
        window.location.href = '/';
      }
      return Promise.reject(new Error('No token available.'));
    }
    config.headers.authorization = token;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      if (!isAlertShown) {
        isAlertShown = true;
        alert('Your session has expired. Please log in again.');
        window.location.href = '/';
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
